export default "__VITE_ASSET__B86X7cgI__"